import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash'
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Customers from './Customers';
import Grid from '@material-ui/core/Grid';
import AccountTransactions from './AccountTransactions';
import AccountInventoryLocations from './AccountInventoryLocations';
import { inject, observer } from 'mobx-react';
import {pending, done} from '../stores/State'
import Settings from '@material-ui/icons/Settings';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Search from '@material-ui/icons/Search';
import InventoryLocationsMap from './InventoryLocationsMap'
import LogisticPlans from './LogisticPlans';

@inject('store')
@observer
/**
 * This class show details from a single Account object
 */
class Account extends Component {

  componentWillMount(){
    this.fetchAccount();
    this.fetchInventoryLocations();
  }

  /**
   * Fetch the Account
   */
  fetchAccount(){
    const store  = this.props.store.accountStore;
    store.fetchAccount(this.props.match.params.id);
  }
  /**
   * Fetch inventory locations for the Account
   */
  fetchInventoryLocations(){
    const store  = this.props.store.inventoryLocationStore;
    store.fetchAccountInventoryLocations(this.props.match.params.id);
  }
  
  /**
   * Render errors from the uiStore for the specified key
   */
  renderErrors(key){    
    const store  = this.props.store.accountUIStore;
    if(!store.errors) return null;
    if(!store.dirty[key]) return null;
    
    const errors = store.errors[key];
    if(!errors) return null;
    return errors.map((error)=><Typography key={error} color='error'>{error}</Typography>)
  }

  /**
   * Render search token form
   */
  renderSearchToken(){
    const { classes } = this.props;
    const store  = this.props.store.accountUIStore;
    
    return(
      <Paper className={classes.paper}>
        <Typography className={classes.title} variant='subheading'><Search/>Search token</Typography>
        <div style={{display: 'flex', alignItems: 'flex-end'}}>
          <TextField
            className={classes.searchCampaignTextField}              
            label='Group'
            type='text'
            value={store.campaignPrefix}
            onChange={(event)=>{
              store.setCampaignPrefix(event.target.value)
            }}
            />
          <TextField
            className={classes.searchTokenTextField}
            label='Token'
            type='text'
            value={store.token}
            onChange={(event)=>{
              store.setToken(event.target.value)
            }}
          />
          <Button
            className={classes.searchTokenButton}
            onClick={()=> this.props.history.push(`/groups/${store.campaignPrefix}/tokens/${store.token}`) }
            type="submit"
            variant="contained"
            size="small"
            disabled={_.has(store.errors, 'token') || _.has(store.errors, 'campaignPrefix')}>Search
          </Button>
        </div>
        {this.renderErrors('campaignPrefix')}
        {this.renderErrors('token')}
      </Paper>
    )
  }

  render() {    
    const { classes } = this.props;
    const store  = this.props.store.accountStore;
    const account = store.account;

    const accountId = _.parseInt(this.props.match.params.id);

    if(store.accountState === pending) return <CircularProgress className={classes.progress} />;
    if(!account) return null;

    return (
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Typography variant='display3'>
              {account.name}
            </Typography>
            <Button size="small" className={classes.settingsButton} variant="contained" color='primary' onClick={()=>this.props.history.push(`/accounts/${accountId}/edit`)}>Settings<Settings className={classes.icon}/></Button>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Customers accountId={accountId}/>
          </Grid>
          <Grid item xs={12}>
            <LogisticPlans accountId={accountId}/>
          </Grid>
          <Grid item xs={12}>
            <AccountTransactions accountId={accountId}/>
          </Grid>
          <Grid item xs={12} lg={8}>
            <AccountInventoryLocations accountId={accountId}/>
          </Grid>
          <Grid item xs={12}>
            <InventoryLocationsMap/>
          </Grid>
          <Grid item md={12} lg={6}>
            {this.renderSearchToken()}
          </Grid>
        </Grid>
          
    );
  }
}

const styles = theme => ({
  paper: {
    padding: 20
  },
  icon:{
    marginLeft: 5
  },
  settingsButton:{
    margin: 5
  },
  searchCampaignTextField:{
    flex: 1    
  },
  searchTokenTextField:{
    marginLeft: 5,
    flex: 3
  },
  searchTokenButton:{
    marginLeft: 5,
    width: 150,
  },
  title:{
    display: 'flex',
    alignItems: 'center'
  }
});

export default withStyles(styles)(Account);


// WEBPACK FOOTER //
// ./src/components/Account.js